import { FC } from 'react';

import {
    ActionCellRenderer,
    ArchiveCellRenderer,
    DetailsCellRenderer,
    ErrorCellRenderer,
    ErrorHeaderRenderer,
    KebabCellRenderer,
    NameCellRenderer,
    OrderCellRenderer,
    LabelCellRenderer,
    DeleteIconCellRenderer,
    WhatsNewActionCellRenderer,
    Table,
    noRowsUpload,
    ToggleSwitchCellRenderer
} from 'common/components';
import { convertTreeToFlatData } from 'common/utils/table';

import LinkCellRenderer from '../custom-cell-renderers/link-cell-renderer/LinkCellRenderer';

import './DataList.scss';
import CopyLabelCellRenderer from '../custom-cell-renderers/copy-label-cell-renderer/CopyLabelCellRenderer';
import CheckboxCellRendererGeneric from '../custom-cell-renderers/check-box-cell-rendere/CheckboxCellRendererGeneric';
import UserPermissionCheckboxCellRenderer from '../custom-cell-renderers/user-permission-checkbox-cell-renderer/UserPermissionCheckboxCellRenderer';
import { FeaturesCheckbox } from '../custom-cell-renderers/features-checkbox-cell-renderer/FeaturesCheckboxCellRenderer';
import FeaturesHierarchyCellRenderer from '../custom-cell-renderers/features-hierarchy-cell-renderer.tsx/FeaturesHierarchyCellRenderer';

type DataListProps = {
    isNoDataVisible: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    columnDefs: any;
    noRowsTemplate?: string;
    suppressDrag?: boolean;
    isScrollToTop?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onReady?: (params: any) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onRowDragEnd?: (params: any) => void;
    fetchNextDataSet?: () => void;
    resetScrollToTop?: () => void;
};

const DataList: FC<DataListProps> = ({
    isNoDataVisible,
    data,
    columnDefs,
    noRowsTemplate,
    suppressDrag,
    isScrollToTop,
    onReady,
    onRowDragEnd,
    fetchNextDataSet,
    resetScrollToTop
}: DataListProps) => {
    return (
        <div className="data-list-container">
            <Table
                suppressRowClickSelection
                suppressCellSelection
                columnDefs={columnDefs}
                rowData={convertTreeToFlatData(data, 0, -1)}
                rowDragManaged={true}
                noRowsTemplate={noRowsTemplate ? noRowsTemplate : noRowsUpload}
                isNoRowsOverlayVisible={isNoDataVisible}
                onGridReady={onReady}
                onRowDragEnd={onRowDragEnd}
                fetchNextDataSet={fetchNextDataSet}
                suppressDrag={suppressDrag}
                isScrollToTop={isScrollToTop}
                resetScrollToTop={resetScrollToTop}
                frameworkComponents={{
                    nameCellRenderer: NameCellRenderer,
                    errorCellRenderer: ErrorCellRenderer,
                    detailsCellRenderer: DetailsCellRenderer,
                    actionCellRenderer: ActionCellRenderer,
                    orderCellRenderer: OrderCellRenderer,
                    errorHeaderRenderer: ErrorHeaderRenderer,
                    kebabCellRenderer: KebabCellRenderer,
                    archiveCellRenderer: ArchiveCellRenderer,
                    LabelCellRenderer: LabelCellRenderer,
                    DeleteIconCellRenderer: DeleteIconCellRenderer,
                    LinkCellRenderer: LinkCellRenderer,
                    CopyLabelCellRenderer: CopyLabelCellRenderer,
                    whatsNewActionCellRenderer: WhatsNewActionCellRenderer,
                    ToggleSwitchCellRenderer: ToggleSwitchCellRenderer,
                    CheckboxCellRendererGeneric,
                    UserPermissionCheckboxCellRenderer,
                    FeaturesCheckbox: FeaturesCheckbox,
                    FeaturesHierarchyCellRenderer: FeaturesHierarchyCellRenderer
                }}
            />
        </div>
    );
};

export default DataList;
